import React from 'react';
import { motion } from 'framer-motion';
import StarIcon from '@mui/icons-material/Star';
export function Testimonials() {
  const testimonials = [{
    quote: 'Monté mi primera mesa gourmet en una tarde. El sistema de temperaturas me ahorró tirar mercadería a la basura.',
    author: 'Mariela G., Córdoba'
  }, {
    quote: 'La vela de queso brie horneado causó furor en los eventos que hago. Mis clientas no podían creer que se comía. Vale cada peso.',
    author: 'Laura P., Rosario · Catering Artesanal'
  }, {
    quote: 'Estaba cansada de las manualidades de siempre que no se venden. Con este formato premium, el margen de ganancia supera el 200%.',
    author: 'Rocio M., Buenos Aires'
  }];
  return <section className="py-12 px-6 bg-brand-ivory" data-id="element-319">
      <div className="max-w-7xl mx-auto" data-id="element-320">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-321">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-white p-8 rounded-xl shadow-sm border border-brand-choco/5 relative" data-id="element-322">
              <div className="flex text-brand-gold mb-4" data-id="element-323">
                {[...Array(5)].map((_, j) => <StarIcon key={j} fontSize="small" data-id="element-324" />)}
              </div>
              <p className="text-brand-choco-deep/90 italic font-serif text-lg leading-relaxed mb-6" data-id="element-325">
                "{t.quote}"
              </p>
              <p className="text-sm font-bold text-brand-choco uppercase tracking-wide" data-id="element-326">
                — {t.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}